import React from 'react';
import adobeWordmark from '../assets/branding/Adobe_Wordmark_RGB_Red.png';

type VipMpHeaderProps = {
  initials: string;
  userText: string;
  authSlot?: React.ReactNode;
};

export function VipMpHeader({ initials, userText, authSlot }: VipMpHeaderProps) {
  return (
    <div className="header">
      <div className="header-left">
        <div className="header-logo">
          <img src={adobeWordmark} alt="Adobe" decoding="async" title="Adobe" />
        </div>
        <div className="header-divider" />
        <div className="header-title">VIP MP Exception Return Form Management</div>
      </div>
      <div className="header-right">
        <div className="user-info">
          <div className="user-avatar">{initials}</div>
          <span className="user-text">{userText}</span>
        </div>
        <div className="header-partner-badge">
          Partner
        </div>
        {authSlot}
      </div>
    </div>
  );
}
